(function () {
  var COOKIE_NAME = 'studio_lashes_institute';
  var COOKIE_DAYS = 30;
  var VALID_VALUES = ['tours-nord', 'chambray'];

  function readCookie() {
    var match = document.cookie.match(
      new RegExp('(?:^|; )' + COOKIE_NAME + '=([^;]+)')
    );
    if (!match) return null;
    var value = decodeURIComponent(match[1]);
    return VALID_VALUES.indexOf(value) !== -1 ? value : null;
  }

  function writeCookie(value) {
    var expires = new Date();
    expires.setTime(expires.getTime() + COOKIE_DAYS * 24 * 60 * 60 * 1000);
    document.cookie =
      COOKIE_NAME +
      '=' +
      encodeURIComponent(value) +
      '; expires=' +
      expires.toUTCString() +
      '; path=/; SameSite=Lax';
  }

  function clearCookie() {
    document.cookie =
      COOKIE_NAME + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax';
  }

  function applyBodyClass(value) {
    var body = document.body;
    body.classList.remove('institute-tours', 'institute-chambray', 'institute-none');
    if (value === 'tours-nord') {
      body.classList.add('institute-tours');
    } else if (value === 'chambray') {
      body.classList.add('institute-chambray');
    } else {
      body.classList.add('institute-none');
    }
    // Onglets de la page RDV : indiquer l'institut actif aux lecteurs d'écran
    var buttons = document.querySelectorAll('[data-institute-select]');
    Array.prototype.forEach.call(buttons, function (el) {
      if (el.hasAttribute('aria-pressed')) {
        el.setAttribute('aria-pressed', el.getAttribute('data-institute-select') === value ? 'true' : 'false');
      }
    });
  }

  function trackEvent(name, params) {
    if (typeof window.gtag === 'function') {
      try {
        window.gtag('event', name, params || {});
      } catch (e) {
        // analytics failure must not break UX
      }
    }
  }

  function isOnRdvPage() {
    // Planity widget on /pages/prendre-rendez-vous is initialized once at
    // page load with the cookie-driven key. Switching institut requires a
    // reload so Planity re-mounts with the right key (Tours vs Chambray WL).
    return /\/pages\/prendre-rendez-vous(\/|$|\?)/.test(window.location.pathname + window.location.search);
  }

  // Capture the institut Planity was initialized with at page load.
  // null cookie defaults to Tours (the fallback used in page.rdv.liquid).
  var PLANITY_INIT_INSTITUTE = readCookie() || 'tours-nord';

  function selectInstitute(value, options) {
    options = options || {};
    if (VALID_VALUES.indexOf(value) === -1) return;
    writeCookie(value);
    applyBodyClass(value);
    trackEvent('institute_selected', {
      institute: value,
      source: options.source || 'selector'
    });
    // Reload only if Planity was loaded with a DIFFERENT institut than the new
    // selection (i.e. it needs a different key). Same institut as init = no reload.
    if (isOnRdvPage() && value !== PLANITY_INIT_INSTITUTE) {
      setTimeout(function () { window.location.reload(); }, 80);
      return;
    }
    setTimeout(function () {
      var container = document.getElementById('planity-rdv') || document.getElementById('$myContainerId');
      if (container) {
        window.dispatchEvent(new Event('resize'));
      }
    }, 50);
  }

  function resetInstitute() {
    clearCookie();
    applyBodyClass(null);
    trackEvent('institute_reset', {});
  }

  function bindHandlers(root) {
    root = root || document;

    var selectButtons = root.querySelectorAll('[data-institute-select]');
    Array.prototype.forEach.call(selectButtons, function (el) {
      if (el.dataset.bound === '1') return;
      el.dataset.bound = '1';
      el.addEventListener('click', function (e) {
        e.preventDefault();
        var value = el.getAttribute('data-institute-select');
        selectInstitute(value, { source: el.getAttribute('data-institute-source') || 'card' });
      });
    });

    var resetLinks = root.querySelectorAll('[data-institute-reset]');
    Array.prototype.forEach.call(resetLinks, function (el) {
      if (el.dataset.bound === '1') return;
      el.dataset.bound = '1';
      el.addEventListener('click', function (e) {
        e.preventDefault();
        resetInstitute();
      });
    });

    var chambrayCtas = root.querySelectorAll('[data-chambray-cta]');
    Array.prototype.forEach.call(chambrayCtas, function (el) {
      if (el.dataset.bound === '1') return;
      el.dataset.bound = '1';
      el.addEventListener('click', function () {
        trackEvent('chambray_redirect', { source: el.getAttribute('data-chambray-cta') || 'cta' });
      });
    });
  }

  // Re-apply body class on init in case the inline early script ran but DOM body wasn't fully ready
  function init() {
    applyBodyClass(readCookie());
    bindHandlers(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-bind when sections are reloaded in the Shopify theme editor
  document.addEventListener('shopify:section:load', function (e) {
    bindHandlers(e.target);
  });

  // Public API for other scripts if needed
  window.StudioLashesInstitute = {
    get: readCookie,
    set: selectInstitute,
    reset: resetInstitute
  };
})();
